import React from 'react'

import { Helmet } from 'react-helmet'

import SignIn1 from '../components/sign-in1'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>在庫管理システム</title>
        <meta property="og:title" content="在庫管理システム" />
      </Helmet>
      <SignIn1></SignIn1>
    </div>
  )
}

export default Home
